export function isVideoBlob(src: string | Blob): boolean | Promise<boolean> {
  if (!src) return false;

  if (src instanceof Blob) {
    return src.type.startsWith('video/');
  }

  if (typeof src === 'string') {
    if (src.startsWith('blob:')) {
      return fetch(src)
        .then((res) => res.blob())
        .then((blob) => blob.type.startsWith('video/'))
        .catch((err) => {
          console.log('Failed to resolve blob URL for video detection:', err);
          return false;
        });
    }

    const ext = src.toLowerCase();
    return ext.match(/\.(mp4|webm|ogg)$/) !== null;
  }

  return false;
}
